export default __webpack_public_path__ + "static/media/ChangeNeutral.6de33afe.svg";